import httpClientWrapper from '@/helpers/HttpClientWrapper'
import jwtHelper from '@/helpers/JwtHelper'

const statsService = {
    loadGlobalStats: loadGlobalStats
}

async function loadGlobalStats() {
    return await httpClientWrapper.get('/api/stats/globalStats', jwtHelper.makeHttpAuthorization())
}

export default statsService